export { EventPromotionBox } from './EventPromotionBox';
